module.exports = __webpack_public_path__ + "static/media/img3.77c7dbb0.jpg";